import { debounceTime } from 'rxjs/operators';
import { WindowService } from 'src/shared/providers/window.service';
import { Component, ViewEncapsulation, EventEmitter, ChangeDetectorRef, OnDestroy, ViewChild, OnInit, signal, computed } from '@angular/core';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import { DateTime as LuxonDateTime } from 'luxon';

import { Analytics } from 'src/providers/analytics/analytics';
import { Addresses } from "src/providers/customer/addresses";
import { AvailableTimesForRange } from 'src/providers/calendar/available-times-for-range';
import { BookJob } from 'src/providers/book-job/book-job';
import { CalendarDay } from 'src/providers/calendar/calendar-day';
import { Card } from 'src/providers/card/card';
import { Schedule } from 'src/providers/schedule/schedule';
import { CustomNavController } from 'src/shared/providers/navigation/custom-nav-controller';
import { Client } from 'src/providers/client/client';
import { Me } from 'src/providers/me/me';
import { TidyStorage } from 'src/shared/providers/tidy-storage';
import { Util } from 'src/shared/util/util';

import { Homekeeper } from 'src/providers/homekeeper/homekeeper'

import { Loading } from 'src/shared/components/loading/loading';

import { AddressModel } from 'src/models/address.model';
import { ParseDateTimePipe } from 'src/shared/pipes/parse-date.pipe';

import { bookJobConfigurations } from 'src/pages/booking/book-job/book-job-configurations';
import { ModalController } from '@ionic/angular';
import { ModalMoreTimesPage } from 'src/pages/booking/modal-more-times/modal-more-times';
import { AvailableTimesModel, ModalMoreTimeDataModel, ProModel, ProTeamServices, SelectedTimesModel } from 'src/models/book-job.model';
import { RadioButtonModel } from 'src/tidy-ui-components/components/form/radio-button/radio-button.model';
import { Subscription } from 'rxjs';
import { Logger } from 'src/providers/logger';
import { OnboardingFlow } from 'src/shared/enums/onboarding-flow';
import { PlanData } from 'src/providers/plans/plan-data';
import { TimeoutableComponent } from 'src/shared/components/timeoutable/timeoutable.component';
import { MatDialog } from '@angular/material/dialog';
import { SubscriptionModalComponent } from 'src/shared/components/subscription-modal/subscription-modal';
import { RightSidePanelService } from 'src/shared/providers/providers/right-side-panel';
import { AuthModalService } from 'src/shared/services/auth-modal.service';
import { GuestAccountService } from 'src/shared/services/guest-account.service';
import { PosthogService } from 'src/shared/services/posthog.service';
import { BookService } from 'src/shared/services/book.service';
import { ConfirmBookingPage } from '../confirm-booking/confirm-booking';
import { ConfirmBookingPaymentPage } from 'src/pages/confirm-booking-payment/confirm-booking-payment';
import { RequestProPage } from 'src/pages/request-pro/request-pro';
import { RequestJobPage } from 'src/pages/request-job/request-job';
import { RequestSubstitutePage } from 'src/pages/request-substitute/request-substitute';

import { Pros } from 'src/providers/pros/pros';
import { buildCategoryHierarchy, MainCategoryDefinition, SubcategoryDefinition } from 'src/shared/constants/service-category-hierarchy';

import { TranslationPipe } from 'src/shared/pipes/translation.pipe';
import { ServiceLabelPipe } from 'src/shared/pipes/service-label.pipe';

@Component({
  templateUrl: 'book-job.html',
  styleUrls: ['./book-job.scss'],
  encapsulation: ViewEncapsulation.None,
  selector: 'book-job',
  standalone: false
})

export class BookJobPage implements OnDestroy, OnInit {

  isLoadingBookingForms = false;
  submitted = false;
  hasImageUploadError: boolean;
  attachments: any;
  selectedCheckboxes: any;
  bookingForms: any;
  bookingForm: UntypedFormGroup;
        isLoadingDynamicForm = false;
  private hasAttemptedToLoadOriginalData = false;
  private preservedFormData: any = null;
  private formDataMonitoringInterval: any = null;
  private hasTrackedInitiateCheckout = false;

  @ViewChild('dynamicBookingForm') dynamicBookingForm: any;
  @ViewChild('categoryTabBar') categoryTabBar: any;

  showCategoryChooser = false;
  collapsableChooser = true;
  choseCategory = signal(false);
  isLoadingServiceDetail = signal(false);
  // The customer's own pro offers nothing of the service type they picked.
  ownProOffersNoneOfType = signal(false);
  // Any Rating is in the pro filter and the customer hasn't chosen never to use TIDY pros.
  canSeeOtherPros = false;
  private hasPreSelectedHouseCleaning = false;
  serviceTypeItems: any[] = [];
  allMainCategories: MainCategoryDefinition[] = [];
  filteredMainCategories: MainCategoryDefinition[] = [];
  selectedMainCategory: MainCategoryDefinition | null = null;
  filteredSubcategories: SubcategoryDefinition[] = [];
  selectedSubcategory: SubcategoryDefinition | null = null;
  categorySearchQuery = '';
  showTabLeftArrow = false;
  showTabRightArrow = true;

  bookingType = signal<any>(undefined);
  bookingExperiment = signal<string | null>(null);
  categoryId: any;
  configuration = signal<any>(undefined);
  providedStartDateIsBeforeTomorrow: boolean;
  customFlowName: string | null;
  customFlowSmallImage: string | null;
  customFlowDiscount: number;
  isUpdatingSubscription: boolean;
  priceExperiment = signal<any>(undefined);
  jobId;
  address: AddressModel;
  bookingId;
  backPage: string;
  originalJobData: any;
  flowType: string;
  choseFrequency = signal(false);
  currentSubscription: any;
  endDay: any;
  frequencyValue = signal<any>(undefined);
  hasValidCC = signal(false);
  moreTimesPerWeekSelected = false;
  ratingChosen = false;
  defaultRatings = []
  prosRatingsOptions: any[] = [];
  proName: string | null;
  proTeamName: string | null;
  startDay: any;
  dateTimes = signal<any[]>([]);
  defaultBookingKey: any;
  privateJobDates: any;
  isRentalClient: boolean;
  isSelfBooking: boolean;
  choseService = signal(false)
  errorMessage: string;
  filterByPro: any;
  shouldNotDefaultToLastPro: boolean;
  subscriptions: Array<Subscription> = [];
  frequencyOrder: number[] = [0,1,2,3,4,5];
  hkId: any;
  loaded: boolean;
  notChoseServiceSentence: string;
  hasNonTrialPaidSubscription = signal(false);
  minRateToBookWithPro = signal<any>(null);
  providedStartDate: any;
  providedStartTime: any;
  planId = signal<any>(undefined);
  proNotBookableReason: any;
  pros: ProModel[] = [];
  proSelected = signal(false);
  selectedDate;
  selectedDuration;
  selectedFrequency = signal<string | null>('Frequency')
  selectedPrice;
  selectedPro: any;
  selectedService = signal('Service');
  selectedBillingType: string;
  selectedServiceImage: string;
  selectedPrivatePro = signal(false);
  selectedServiceData = signal<ProTeamServices>(null);
  selectedTime;
  services = signal<ProTeamServices[]>([]);
  servicesResponse: ProTeamServices[] = [];
  shouldInsteadAddJob: any;
  showSavingsText: boolean;
  showMoreServices: boolean;
  subscriptionType = signal<any>(undefined);
  subscriptionExperiment = signal<any>(undefined);
  tidyPlusSubscription: any;
  noAvailableTimes = signal(true);
  isLoadingTimes = false;
  isLoadingPrivateTimes = false;
  isLoggingJob: boolean;
  logJobTimeItems: any = [];
  dateLabel: string;
  secondDateLabel: string;
  thirdDateLabel: string;
  selectedTimeValue: any;
  waterfallSettings: any;
  hasBookingFormError: boolean;
  form: UntypedFormGroup;
  allTimesSelected = [];
  hasTrackedDateTimeReached = false;
  filteredProsRatingsOptions: any[] = [];
  newValue: string;
  dialogParams: any;
  isRightSideContent = true;
  topNavHeight = 0;
  private resizeObserver: ResizeObserver;


  private serviceLabelPipe = new ServiceLabelPipe();
  boundConfirmBooking = this.confirmBooking.bind(this);
  boundTurnOnTidyFindNewPros = this.turnOnTidyFindNewPros.bind(this);
  boundGoToAddPro = this.goToAddPro.bind(this);
  boundChangeServiceRates = this.changeServiceRates.bind(this);

  displayPrice = computed(() =>
    this.bookJobService.getDisplayPriceForJob(
      this.planId(), this.selectedServiceData(), this.selectedFrequency(),
      this.choseFrequency(), this.bookingType(), this.hasNonTrialPaidSubscription(),
      this.priceExperiment(), this.bookingExperiment(), this.customFlowName,
      this.selectedPrivatePro()
    )
  );

  displayPriceMap = computed(() => {
    const map = new Map<any, string>();
    for (const service of this.services()) {
      map.set(service, this.bookJobService.getDisplayPriceForJob(
        this.planId(), service, this.selectedFrequency(),
        this.choseFrequency(), this.bookingType(), this.hasNonTrialPaidSubscription(),
        this.priceExperiment(), this.bookingExperiment(), this.customFlowName,
        this.selectedPrivatePro()
      ));
    }
    return map;
  });

  savingsText = computed(() => this.getSavingsText());

  showRequestProSignal = computed(() => this.calculateShowRequestPro());

  showRequestJobSignal = computed(() => this.calculateShowRequestJob());

  isHourlyService = computed(() => this.serviceLabelPipe.transform(this.selectedService()).includes('hour'));

  // House Cleaning is the default landing service, so treat "nothing selected yet"
  // as house cleaning. Used to segment booking funnel events by service type.
  get isHouseCleaningSelected(): boolean {
    return (this.selectedSubcategory?.apiKey ?? 'regular_cleaning') === 'regular_cleaning';
  }

  serviceFrequencyLabelSignal = computed(() => {
    const service = this.serviceLabelPipe.transform(this.selectedService());
    if (!this.choseService()) {return 'Select Service';}
    if ((this.choseService() && !this.choseFrequency()) ||
        this.configuration()?.hide_frequency ||
        this.selectedFrequency() === null) {
      return service;
    }
    return `${service} - ${this.selectedFrequency()}`;
  });

constructor(
    private addresses: Addresses,
    private analytics: Analytics,
    private authModalService: AuthModalService,
    private availableTimesForRange: AvailableTimesForRange,
    public bookJobService: BookJob,
    private calendarDay: CalendarDay,
    private card: Card,
    private changeDetectorRef: ChangeDetectorRef,
    private client: Client,
    private dialog: MatDialog,
    private fb: UntypedFormBuilder,
    private guestAccountService: GuestAccountService,
    private homekeeper: Homekeeper,
    private logger: Logger,
    public me: Me,
    private modalCtrl: ModalController,
    private navCtrl: CustomNavController,
    private planData: PlanData,
    private posthogService: PosthogService,
    private bookService: BookService,
    private prosService: Pros,
    private rightSidePanelService: RightSidePanelService,
    private schedule: Schedule,
    private storage: TidyStorage,
    private util: Util,
    public windowService: WindowService
  ) {
    this.form = this.fb.group({
      proOption: ['', Validators.required],
      pros: ['', Validators.minLength(0)],
      service: ['', Validators.required],
      frequency: [''],
      time: ['', Validators.required],
      privateDate: [''],
      serviceCategories: ['']
    });
    this.bookingForm = this.fb.group({});
  }

  async ngOnInit() {
    try {
      this.isRightSideContent = await this.storage.retrieve('dialog-right-side-open') || false;
      this.dialogParams = await this.storage.retrieve('dialog-params');
      if (this.dialogParams) {this.dialogParams['showSameDayTimeAlert'] = null;}
      await this.storage.save('dialog-params', this.dialogParams);
      await this.storage.save('showSameDayTimeAlert', null);
      await this.loadDataAndParams();
      await this.watchFormChangesAndSaveCartMetadata();
      this.observeTopNavHeight();
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
      console.error('err', err);
      this.util.showError(this.errorMessage);
      this.logger.error(err);
    }
  }

  private observeTopNavHeight() {
    const element = document.getElementById('top-nav-height');
    if (element) {
      this.topNavHeight = element.offsetHeight;
      let lastHeight = this.topNavHeight;
      this.resizeObserver = new ResizeObserver(entries => {
        for (const entry of entries) {
          const newHeight = entry.contentRect.height;
          if (newHeight !== lastHeight) {
            lastHeight = newHeight;
            this.topNavHeight = newHeight;
            // Use requestAnimationFrame to avoid multiple change detection cycles
            requestAnimationFrame(() => {
              this.changeDetectorRef.detectChanges();
            });
          }
        }
      });
      this.resizeObserver.observe(element);
    }
  }

  ngOnDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });

    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }

    // Clean up form data monitoring
    this.stopFormDataMonitoring();
  }

  async watchFormChangesAndSaveCartMetadata() {
    const storedCartMetadata = await this.storage.retrieve('cartMetadata') || {};
    const isFirstBooking = await this.storage.retrieve('isFirstBooking');
    if (isFirstBooking) {
      this.form.valueChanges.pipe(debounceTime(1000)).subscribe(async (value) => {
        const updatedCartMetadata = {
          ...storedCartMetadata,
          bookingForm: value,
          addressName: this.address?.address_name || (`${this.address?.address1  } ${  this.address?.address2  }, ${  this.address?.zip  }, ${  this.address?.add_state}`),
        }
        await this.storage.save('cartMetadata', updatedCartMetadata);
        const payload = { key: 'cartMetadata', value: JSON.stringify(updatedCartMetadata) };
        await this.client.addMetadata(payload);
      });
    }
  }

  @Loading('', true)
  async loadDataAndParams() {
    try {
      this.rightSidePanelService.setDialogLoading(true);
      this.errorMessage = '';
      this.loaded = false;
      await this.getPageParams();
      await this.initPageData();
      // Apply chooser restore (back-nav) or House Cleaning pre-select AFTER
      // initPageData so its fetchPros / fetchServices flow cannot clobber the
      // restored choseService / choseFrequency / form.service / form.frequency.
      if (this.showCategoryChooser) {
        await this.applyRestoreOrPreSelectHouseCleaning();
      }
      this.configuration.set(bookJobConfigurations[this.bookingType()]);
      const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
      this.backPage = await this.storage.retrieve('bookJobBackPage') || (shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list');
      if (this.isRentalClient) {
        this.isUpdatingSubscription = localStorage.getItem('isUpdatingSubscription') === 'true';
        const subscriptionTypes = await this.me.getSubscriptionTypes();
        this.hasNonTrialPaidSubscription.set(await this.me.checkIfHasNonTrialPaidSubscription(subscriptionTypes));
        this.tidyPlusSubscription = subscriptionTypes.find((type) => type.key === 'tidy_plus_yearly_subscription_not_trial');
        this.storage.save('tidyPlusSubscription', this.tidyPlusSubscription);
        this.currentSubscription = await this.storage.retrieve('currentSubscription');
        this.subscriptionType.set(this.me.getSubscriptionType(this.currentSubscription?.key));
        if (this.subscriptionType() === 'Free') {
          this.isUpdatingSubscription = false;
        }
      }
      this.rightSidePanelService.setDialogPageTitle(this.configuration()?.title);
      this.loaded = true;
      this.rightSidePanelService.setDialogLoading(false);
      const isReschedule = this.bookingType() === 'reschedule_job' || this.bookingType() === 'reschedule_plan';
      if (!isReschedule) {
        this.posthogService.capture('booking_view_entered', {
          variant: 'control',
          has_credit_card: this.hasValidCC(),
          booking_type: this.bookingType(),
          is_desktop: this.windowService.isDesktopRes,
          is_house_cleaning: this.isHouseCleaningSelected,
        });
      }

      // Track initiate_checkout for consumers (non-rental) when they see plan options
      // Only fire once, only for real accounts (not guest), and only on first booking
      if (this.hasTrackedInitiateCheckout) {
        return;
      }
      const isGuestAccount = await this.storage.retrieve('isGuestAccount');
      const isFirstBooking = await this.storage.retrieve('isFirstBooking');
      if (!this.isRentalClient && !isGuestAccount && isFirstBooking) {
        this.analytics.trackInitiateCheckout();
        this.hasTrackedInitiateCheckout = true;
      }
    } catch (err) {
      this.showIssueLoadingPageAlert();
    }
  }

  async getPageParams() {
    this.address = await this.getParam('address');
    if (this.address === null || this.address === undefined) {
      return this.showIssueLoadingPageAlert();
    }
    this.bookingType.set(await this.getParam('bookingType') || 'add_job');
    this.isLoggingJob = await this.getParam('isLoggingJob');
    this.jobId = await this.getParam('jobId');
    this.flowType = await this.getParam('flowType');
    this.planId.set(await this.getParam('planId'));
    this.bookingId = await this.getParam('bookingId');
    this.defaultBookingKey = await this.getParam('defaultBookingKey');
    this.categoryId = await this.getParam('categoryId') || 1;
    this.showCategoryChooser = !!(await this.getParam('showCategoryChooser'));
    const collapsableChooserParam = await this.getParam('collapsableChooser');
    this.collapsableChooser = collapsableChooserParam !== false;
    if (this.showCategoryChooser) {
      this.loadServiceCategories();
    }
    this.isSelfBooking = await this.getParam('isSelfBooking');
    this.shouldNotDefaultToLastPro = await this.getParam('shouldNotDefaultToLastPro');
    this.hkId = await this.getParam('hkId');
    this.filterByPro = await this.getParam('filterByPro');
    this.pros = this.getProsParam();

    // Get original job data for rescheduling
    this.originalJobData = await this.getParam('originalJobData');

    const today = LuxonDateTime.local().toFormat('MM-dd-yyyy');
    this.providedStartDate = await this.getParam('providedStartDate') || today;
    this.providedStartTime = await this.getParam('providedStartTime');
    const providedDate = LuxonDateTime.fromFormat(this.providedStartDate, 'MM-dd-yyyy');
    const currentDate = LuxonDateTime.local();
    if (providedDate <= currentDate) {
      this.providedStartDate = this.startDay;
      this.providedStartDateIsBeforeTomorrow = true;
    }
    this.shouldInsteadAddJob = await this.getParam('shouldInsteadAddJob');
  }

  async getParam(paramName): Promise<any> {
    let param = this.dialogParams?.[paramName];
    if (param === null || param === undefined) {
      param = this.navCtrl.getParam(paramName);
    }
    if (param === null || param === undefined) {
      param = await this.storage.retrieve(paramName);
    }
    this.storage.save(paramName, param);
    return param;
  }

  // Deliberately NOT getParam(): the 'pros' storage slot is a single global key with no
  // address or category scoping, and the Messages pages write an account-wide contact list
  // to it in a different shape. Falling back to storage let another context's list stand in
  // for this booking's pros — and because fetchPros() only calls calendar/filters when the
  // list is empty, the stale list rendered and the API never fired, so the client's own Pros
  // appeared to vanish. Read the pro list only from an explicit nav/dialog param and never
  // persist it back; with no param, fetchPros() loads the right list for this address.
  private getProsParam(): any {
    const param = this.dialogParams?.['pros'];
    return (param === null || param === undefined) ? this.navCtrl.getParam('pros') : param;
  }

  async initPageData() {
    try {
      this.hasValidCC.set(await this.card.hasValidCard());
      const client = await this.client.getClientInfo();
      //this.waterfallSettings = await this.client.getWaterfallSettings();
      this.isRentalClient = client.customer_account.account_type === 'rental';
    } catch (err) {
      console.error('err', err);
      this.errorMessage = err?.error?.message ?? err?.message;
      this.logger.error(err);
      this.util.showError(this.errorMessage);
      throw err;
    }
    this.bookingExperiment.set(localStorage.getItem('bookingExperiment'));
    this.priceExperiment.set(this.bookJobService.getPriceExperiment());
    this.subscriptionExperiment.set(this.bookJobService.getSubscriptionExperiment());
    this.customFlowName = localStorage.getItem('customFlowName');
    this.customFlowSmallImage = localStorage.getItem('customFlowSmallImage');
    this.customFlowDiscount = parseInt(localStorage.getItem('customFlowDiscount'));
    if (this.customFlowName) {
      this.bookingExperiment.set('consumer-control');
      localStorage.setItem('bookingExperiment', this.bookingExperiment());
    }
    this.logJobTimeItems = this.bookJobService.getJobTimeItems();
    if (this.flowType === 'private') {
      this.proName = localStorage.getItem('proName');
      this.proTeamName = localStorage.getItem('proTeamName');
    }
    this.notChoseServiceSentence =  this.bookingType() === 'add_one_time_job' ? 'Select service to see times' : 'Select service & frequency to see times';
    this.configuration.set(bookJobConfigurations[this.bookingType()]);
    this.startDay = await this.calendarDay.getBookJobStartDate(this.address.timezone);
    this.endDay = this.calendarDay.addDays(this.startDay, 28);
    await this.fetchPros();
    const defaultProOption: any = await this.determineDefaultProOption();
    console.warn('[initPageData] defaultProOption:', defaultProOption, 'prosRatingsOptions:', this.prosRatingsOptions);
    this.form.patchValue({ proOption: defaultProOption });
    this.form.patchValue({ service: this.defaultBookingKey });
    await this.fetchServices(defaultProOption);
    this.dateLabel = this.getDateLabel();
    this.form.get('privateDate')?.clearValidators();
    this.form.get('privateDate')?.updateValueAndValidity();
  }

  async determineDefaultProOption() {
    if (this.isLoggingJob || this.shouldNotDefaultToLastPro) {
      return this.prosRatingsOptions[0].value;
    }
    const request = {
      frequency: 'once',
      start_date: this.startDay,
      end_date: this.endDay,
      region_id: this.address.region_id,
      address_id: this.address.id,
      service_type_key: 'regular_cleaning.one_hour',
      filter: ''
    };

    if (this.hkId && this.filterByPro) {
      return request.filter = `homekeeper:${this.hkId}`;
    }

    try {
      if (this.flowType === OnboardingFlow.PRIVATE) {
        request.filter = `homekeeper:${this.hkId}`;
      } else {
        const lastPro = this.pros.find(pro => pro.default);
        if (lastPro?.private) {
          return lastPro.filter;
        }
        const filtersToTry = [
          lastPro?.filter,
          'prioritized_v2:4_6',
          'all'
        ].filter(Boolean);
        for (const filter of filtersToTry) {
          request.filter = filter;
          const response = await this.availableTimesForRange.getAvailableTimes(request);
          this.handleTimeResponse(response);
          if (!this.noAvailableTimes()) {
            break;
          }
        }
      }
    } catch(err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      this.logger.error(err, 'book-job-trying-get-calendar');
      this.util.showError(this.errorMessage);
      console.error('err', err);
    }
    return request.filter;
  }

  async fetchPros() {
    try {
      if (!this.pros?.length) {
        this.pros = await this.bookJobService.fetchPros(this.categoryId);
      }
      this.prosRatingsOptions = this.parseProsForFilter();
      this.filteredProsRatingsOptions = this.buildFilteredProsRatingsOptions();
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
      this.util.showError(this.errorMessage);
      this.logger.error(err);
      console.error('err', err);
    }
    this.form.patchValue({
      pros: null,
      service: null,
      frequency: null,
      privateDate: null,
      time: null
    });
  }

  parseProsForFilter() {
    const array: any = [];
    this.pros.map(pro => {
      const rating4 = pro.name === '4+ Star Rating';
      const filter = rating4 ? '4' : pro.filter;
      if ((this.isLoggingJob && pro.private) || !this.isLoggingJob) {
        array.push({
          viewValue: pro.name,
          value: filter
        })
      }
    });
    return array;
  }

  private buildFilteredProsRatingsOptions() {
    return this.prosRatingsOptions;
  }

  async changeFilter(pro) {
    this.isLoggingJob = false;
    this.ratingChosen = true;
    this.newValue = pro.value;
    this.choseFrequency.set(false);

    // Preserve the current form data BEFORE changing pro/service
    this.preserveFormData();

    await this.fetchServices(pro);
    // The kept service key belongs to the previous pro's list, so for a non-cleaning
    // type nothing matches and the page has no service or times left to pick.
    if (this.showCategoryChooser && this.selectedSubcategory && this.selectedSubcategory.apiKey !== 'regular_cleaning') {
      await this.selectSubcategory(this.selectedSubcategory);
    }
  }

  seeOtherProsForService = async () => {
    this.newValue = 'all';
    this.form.patchValue({ proOption: 'all' });
    await this.fetchServices('all');
    if (this.selectedSubcategory) {
      await this.selectSubcategory(this.selectedSubcategory);
    }
  };

  async fetchServices(proFilter: string, showAll = false) {
    this.selectedPro = this.prosRatingsOptions.find((option) => proFilter === option.value)
      || this.prosRatingsOptions[0]
      || { value: proFilter || 'all', viewValue: 'Any Rating' };
    const selectedProResponseData = this.pros.find((pro) => pro.name === this.selectedPro.viewValue);
    this.selectedPrivatePro.set(selectedProResponseData?.private ?? false);
    if (this.selectedPrivatePro()) {
      const proId = parseInt(proFilter.replace('homekeeper:', ''), 10);
      try {
        this.servicesResponse = await this.bookJobService.fetchTeamServices(proId, this.categoryId);
        this.services.set(this.servicesResponse);
        this.proSelected.set(true);
      } catch (err) {
        this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
        console.error('err', err);
        this.util.showError(this.errorMessage);
        this.logger.error(err);
      }
    } else {
      const defaultRatings = [
        'prioritized_v2:4_6',
        'prioritized_v2:4_2',
        '4',
        'all'
      ];
      const apiFilter = proFilter === '4' ? 'all' : (selectedProResponseData?.filter || proFilter || 'all');
      this.proSelected.set(!defaultRatings.includes(apiFilter));
      try {
        this.services.set(await this.bookJobService.fetchRequiredTeamServices(apiFilter, this.proSelected(), this.categoryId));
      } catch (err) {
        this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
        console.error('err', err);
        this.util.showError(this.errorMessage);
        this.logger.error(err);
      }
    }
    this.setSelectedService(showAll);
  }

  setSelectedService(showAll = false) {
    const formService = this.form.get('service')?.value;
    const selectedService = this.services().find(service => service.key === formService);
    if (selectedService) {
      this.selectService(selectedService, showAll);
    } else {
      this.showMoreServices = true;
      this.choseService.set(false);
      this.selectedServiceData.set(null);
      this.choseFrequency.set(false);
      this.form.patchValue({
        service: null,
        frequency: null,
      });
    }
  }

  async loadServiceCategories() {
    try {
      const categories = await this.prosService.getServiceCategories();
      this.serviceTypeItems = categories.map((category: any) => ({
        ...category,
        icon: category.icon_url,
        viewValue: category.name === 'Regular Cleaning' ? 'Cleaning' : category.name,
        value: category.id
      }));
      const hierarchy = buildCategoryHierarchy(categories);
      this.allMainCategories = hierarchy;
      this.filteredMainCategories = hierarchy;
      this.selectedMainCategory = hierarchy[0] || null;
      this.filteredSubcategories = this.selectedMainCategory?.subcategories ?? [];
      this.changeDetectorRef.markForCheck();
      setTimeout(() => this.refreshTabBarArrows(), 0);
      // Restore + House-Cleaning pre-select are now done in
      // applyRestoreOrPreSelectHouseCleaning, called after initPageData so
      // initPageData's fetchPros/fetchServices don't clobber the restored
      // chooser state.
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
      this.util.showError(this.errorMessage);
      this.logger.error(err);
    }
  }

  // Persists the user's current chooser state to localStorage (sync) so it can
  // be re-applied if they navigate to a downstream page (request-job /
  // confirm-booking) and click back. Called before navigating away. Cleared on
  // fresh open of the booking view in book.service.ts:goToBookJob.
  private saveBookingChooserState(): void {
    if (!this.showCategoryChooser) {return;}
    if (!this.selectedSubcategory) {return;}
    let bookingFormAnswers: any = null;
    try {
      if (this.dynamicBookingForm?.isReady) {
        bookingFormAnswers = this.dynamicBookingForm.buildBookingFormData();
      }
    } catch (_err) {
      bookingFormAnswers = null;
    }
    const state = {
      selectedSubcategoryApiKey: this.selectedSubcategory.apiKey,
      categoryId: this.categoryId,
      proOption: this.form.value.proOption,
      service: this.form.value.service,
      frequency: this.form.value.frequency,
      time: this.form.value.time,
      bookingFormAnswers,
      attachments: this.attachments || [],
      addressId: this.address?.id,
      timestamp: Date.now(),
    };
    try {
      localStorage.setItem('book-job-chooser-restore-state', JSON.stringify(state));
    } catch (_e) { /* noop */ }
  }

  // Polls for this.startDay to be set (initPageData runs in parallel with
  // loadServiceCategories — initPageData is what populates startDay/endDay).
  private async waitForStartDay(maxMs = 5000): Promise<boolean> {
    const start = Date.now();
    while (!this.startDay && Date.now() - start < maxMs) {
      await new Promise(r => setTimeout(r, 50));
    }
    return !!this.startDay;
  }

  // Polls for this.allMainCategories to be populated (loadServiceCategories
  // runs in parallel with initPageData; the restore + House-Cleaning pre-select
  // step needs categories loaded first).
  private async waitForServiceCategoriesLoaded(maxMs = 5000): Promise<boolean> {
    const start = Date.now();
    while (!this.allMainCategories?.length && Date.now() - start < maxMs) {
      await new Promise(r => setTimeout(r, 50));
    }
    return !!this.allMainCategories?.length;
  }

  // Called from loadDataAndParams AFTER initPageData has finished. By running
  // last we avoid the race where initPageData's fetchPros/fetchServices
  // resets choseService/choseFrequency that restore had set.
  private async applyRestoreOrPreSelectHouseCleaning(): Promise<void> {
    await this.waitForServiceCategoriesLoaded();
    const restored = await this.restoreBookingChooserState();
    if (restored) {return;}
    if (this.hasPreSelectedHouseCleaning || this.choseCategory()) {return;}
    const houseCleaning = this.allMainCategories
      .flatMap(cat => cat.subcategories)
      .find(sub => sub.apiKey === 'regular_cleaning');
    if (!houseCleaning) {return;}
    this.hasPreSelectedHouseCleaning = true;
    // For the House Cleaning fresh-open case, initPageData has already set
    // services / selectedServiceData / choseService via its fetchServices
    // flow. We only need to wire up the chooser UI here — calling the full
    // selectSubcategory() would tear down that state. Just mark the category
    // as selected so the chooser highlights House Cleaning.
    this.selectedSubcategory = houseCleaning;
    this.choseCategory.set(true);
    this.changeDetectorRef.detectChanges();
  }

  // Restores chooser state saved by saveBookingChooserState. Returns true if
  // restored so the caller knows to skip the default House Cleaning pre-select.
  private async restoreBookingChooserState(): Promise<boolean> {
    if (!this.showCategoryChooser) {return false;}
    let state: any = null;
    try {
      const raw = localStorage.getItem('book-job-chooser-restore-state');
      if (raw) {state = JSON.parse(raw);}
    } catch (_e) {return false;}
    if (!state) {return false;}
    if (state.addressId !== this.address?.id) {return false;}
    if (Date.now() - (state.timestamp || 0) > 30 * 60 * 1000) {return false;}
    if (!state.selectedSubcategoryApiKey) {return false;}
    const sub = this.allMainCategories
      .flatMap(c => c.subcategories)
      .find(s => s.apiKey === state.selectedSubcategoryApiKey);
    if (!sub) {return false;}
    // Set preservedFormData + attachments BEFORE selectSubcategory so that when
    // the dynamic-booking-form component mounts and emits componentInitialized,
    // onFormDataChange can immediately restore the user's typed answers.
    if (state.bookingFormAnswers && state.bookingFormAnswers.input_answers?.length > 0) {
      this.preservedFormData = state.bookingFormAnswers;
    }
    if (state.attachments && Array.isArray(state.attachments)) {
      this.attachments = state.attachments;
    }
    // Wait for startDay so selectFrequency inside selectSubcategory can fetch
    // available times.
    await this.waitForStartDay();
    this.hasPreSelectedHouseCleaning = true;
    // The saved service and times belong to the pro the customer picked, which
    // can differ from the default pro initPageData selected.
    if (state.proOption && state.proOption !== this.form.value.proOption
        && this.prosRatingsOptions?.some(option => option.value === state.proOption)) {
      this.newValue = state.proOption;
      this.ratingChosen = true;
      this.form.patchValue({ proOption: state.proOption });
      await this.fetchServices(state.proOption);
    }
    // selectSubcategory's auto-select for non-cleaning now awaits selectFrequency
    // internally, so when this resolves choseService / choseFrequency / dateTimes
    // are all set for the default 'once' frequency.
    await this.selectSubcategory(sub);
    // Only re-select if the saved service differs from what selectSubcategory
    // auto-picked.
    const currentServiceKey = this.selectedServiceData()?.key;
    const targetServiceKey = state.service || this.services()?.[0]?.key;
    if (targetServiceKey && targetServiceKey !== currentServiceKey) {
      const matchingService = this.services().find((svc: any) => svc.key === targetServiceKey);
      if (matchingService) {
        this.selectService(matchingService);
      }
    }
    // Only re-call selectFrequency if the saved frequency differs from the
    // one selectSubcategory auto-picked ('once').
    const targetFrequency = state.frequency || 'once';
    if (targetFrequency !== this.frequencyValue()) {
      const selected = this.selectedServiceData();
      const freq = (selected as any)?.frequencies?.find((f: any) => f.value === targetFrequency)
        || { value: targetFrequency, viewValue: targetFrequency === 'once' ? new TranslationPipe().transform('One Time') : targetFrequency };
      await this.selectFrequency(freq);
      this.form.patchValue({ frequency: targetFrequency });
    }
    if (state.time) {
      const [savedDate] = state.time.split(' ');
      // A private pro's times load one day at a time (the Select Date day), and
      // that day starts back on the first one, so load the saved day's times.
      const savedDayLoaded = this.dateTimes().some(day => day.date === savedDate);
      if (this.selectedPrivatePro() && !savedDayLoaded
          && this.privateJobDates?.some(day => day.value === savedDate)) {
        this.form.patchValue({ privateDate: savedDate });
        await this.changeDay(savedDate);
      }
      let matchedTime: { value: string; viewValue: string; pros: number[] } | null = null;
      for (const day of this.dateTimes()) {
        if (day.date === savedDate) {
          matchedTime = (day.times.find((t: any) => t.value === state.time) as any) || null;
          if (matchedTime) {break;}
        }
      }
      if (matchedTime) {
        this.allTimesSelected = [matchedTime];
        this.selectedDate = this.formatDate(matchedTime.value, 'ddd MMM d');
        this.selectedTime = matchedTime.viewValue;
        this.selectedTimeValue = matchedTime.value;
        this.form.patchValue({ time: matchedTime.value, pros: matchedTime.pros });
        this.dateLabel = this.getDateLabel();
      } else {
        // Leave Review Booking disabled until a time is picked: with no time
        // in allTimesSelected the booking has no dates to confirm.
        this.allTimesSelected = [];
        this.form.patchValue({ time: null });
      }
    }
    return true;
  }

  changeCategory = () => {
    this.choseCategory.set(false);
    this.choseService.set(false);
    this.selectedSubcategory = null;
    this.ownProOffersNoneOfType.set(false);
    this.selectedServiceData.set(null);
    this.bookingForms = null;
    this.form.patchValue({ service: null, frequency: null, time: null });
    this.categoryId = 1;
    this.changeDetectorRef.detectChanges();
    setTimeout(() => this.refreshTabBarArrows(), 0);
  };

  private refreshTabBarArrows() {
    const el = this.categoryTabBar?.nativeElement;
    if (!el) {
      this.showTabLeftArrow = false;
      this.showTabRightArrow = true;
      return;
    }
    this.showTabLeftArrow = el.scrollLeft > 10;
    this.showTabRightArrow = el.scrollLeft < el.scrollWidth - el.clientWidth - 10;
    this.changeDetectorRef.detectChanges();
  }

  selectMainCategory = (category: MainCategoryDefinition) => {
    this.selectedMainCategory = category;
    this.selectedSubcategory = null;
    this.ownProOffersNoneOfType.set(false);
    if (this.categorySearchQuery?.trim()) {
      const lowerQuery = this.categorySearchQuery.toLowerCase();
      const catNameMatches = category.name.toLowerCase().includes(lowerQuery);
      this.filteredSubcategories = catNameMatches
        ? category.subcategories
        : category.subcategories.filter(sub => sub.name.toLowerCase().includes(lowerQuery));
    } else {
      this.filteredSubcategories = category.subcategories;
    }
    this.changeDetectorRef.detectChanges();
  };

  selectSubcategory = async (sub: SubcategoryDefinition) => {
    this.selectedSubcategory = sub;
    const apiCategory = this.serviceTypeItems.find(item => item.key === sub.apiKey);
    const isHouseCleaning = sub.apiKey === 'regular_cleaning';
    this.choseCategory.set(true);
    this.categoryId = isHouseCleaning ? 1 : (apiCategory?.value ?? this.categoryId);
    this.choseService.set(false);
    this.choseFrequency.set(false);
    this.selectedServiceData.set(null);
    this.selectedFrequency.set(null);
    this.bookingForms = null;
    this.showMoreServices = false;
    this.form.patchValue({ service: null, frequency: null, time: null });
    this.ownProOffersNoneOfType.set(false);
    this.isLoadingServiceDetail.set(true);
    this.changeDetectorRef.detectChanges();
    try {
      // The private-pro times request finds the pro from the team id in the
      // service key, so with the customer's own pro selected list that pro's
      // services (keys like 458620.carpet_cleaning.one_hour), as fetchServices does.
      const newServices = this.selectedPrivatePro()
        ? await this.bookJobService.fetchTeamServices(parseInt(this.selectedPro.value.replace('homekeeper:', ''), 10), this.categoryId)
        : await this.bookJobService.fetchRequiredTeamServices('all', false, this.categoryId);
      this.services.set(newServices);
      this.ownProOffersNoneOfType.set(this.selectedPrivatePro() && !isHouseCleaning && !newServices?.length);
      this.canSeeOtherPros = !!this.prosRatingsOptions?.some(option => option.value === 'all')
        && this.waterfallSettings?.key !== 'never_use_tidy';
      if (!isHouseCleaning && newServices && newServices.length > 0) {
        this.selectService(newServices[0]);
        // Await so restore callers can rely on choseFrequency / dateTimes /
        // selectedFrequency being fully set before they continue.
        await this.selectFrequency({ value: 'once', viewValue: new TranslationPipe().transform('One Time') });
        this.form.patchValue({ frequency: 'once' });
      }
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
      this.logger.error(err);
      this.util.showError(this.errorMessage);
    }
    this.isLoadingServiceDetail.set(false);
    this.changeDetectorRef.detectChanges();
  };

  filterCategories = (query: string) => {
    this.categorySearchQuery = query;
    this.applySearchFilter(query);
    this.changeDetectorRef.detectChanges();
  };

  private applySearchFilter(query: string) {
    if (!query?.trim()) {
      this.filteredMainCategories = this.allMainCategories;
      this.filteredSubcategories = this.selectedMainCategory?.subcategories ?? [];
      return;
    }
    const lowerQuery = query.toLowerCase();
    this.filteredMainCategories = this.allMainCategories.filter(
      cat => cat.name.toLowerCase().includes(lowerQuery) ||
        cat.subcategories.some(sub => sub.name.toLowerCase().includes(lowerQuery))
    );
    if (this.filteredMainCategories.length > 0 &&
        !this.filteredMainCategories.some(cat => cat.id === this.selectedMainCategory?.id)) {
      this.selectedMainCategory = this.filteredMainCategories[0];
    }
    const cat = this.selectedMainCategory;
    if (cat) {
      const catNameMatches = cat.name.toLowerCase().includes(lowerQuery);
      this.filteredSubcategories = catNameMatches
        ? cat.subcategories
        : cat.subcategories.filter(sub => sub.name.toLowerCase().includes(lowerQuery));
    } else {
      this.filteredSubcategories = [];
    }
  }

  scrollTabBarRight = () => {
    this.categoryTabBar?.nativeElement?.scrollBy({ left: 200, behavior: 'smooth' });
  };

  scrollTabBarLeft = () => {
    this.categoryTabBar?.nativeElement?.scrollBy({ left: -200, behavior: 'smooth' });
  };

  onTabBarScroll = () => {
    const el = this.categoryTabBar?.nativeElement;
    if (!el) {return;}
    this.showTabLeftArrow = el.scrollLeft > 10;
    this.showTabRightArrow = el.scrollLeft < el.scrollWidth - el.clientWidth - 10;
  };

  handleServiceClick(service: ProTeamServices) {
    if (this.selectedServiceData()?.key === service.key) {
      return;
    }
    this.selectService(service);
  }

  selectService(service: ProTeamServices, showAll = false) {
    this.showSavingsText = false;
    this.choseService.set(true);
    this.selectedServiceData.set(service);
    this.selectedService.set(service.title);
    this.selectedBillingType = service.billingType;
    this.selectedServiceImage = service.image;
    this.selectedDuration = service.duration;
    const selectedFrequency = this.form.value.frequency;
    this.form.patchValue({ service: service.key, time: null });
    if(showAll){
      this.form.patchValue({frequency: selectedFrequency });
      return ;
    } else {
      this.form.patchValue({frequency: null });
      this.selectedFrequency.set(null);
    }
    this.selectedDate = null;
    this.selectedTime = null;
    this.dateTimes.set([]);
    if (this.configuration()?.hide_frequency || this.isLoggingJob) {
      this.selectFrequency(this.configuration()?.frequency_value || { viewValue: new TranslationPipe().transform('One Time'), value: 'once' });
    }

    this.bookingForms = null;
    this.attachments = [];
    const shouldGetBookingForm = this.categoryId !== 1;
    if (shouldGetBookingForm) {
      this.getBookingForm();
    }

    // Preserve the current form data before clearing forms
    this.preserveFormData();
  }

  async getBookingForm() {
    try {
      this.isLoadingBookingForms = true;
      this.isLoadingDynamicForm = true;
      this.bookingForms = await this.bookJobService.getBookingFormTemplate(this.form.value.service);
      if (this.bookingForms?.length > 0) {
        // Dynamic form controls are now handled by the dynamic-booking-form component
        this.selectedCheckboxes = [];

        // Keep dynamic form loading until component is ready
        setTimeout(() => {
          this.isLoadingDynamicForm = false;

          // If this is a rescheduling flow and we haven't loaded the data yet, try to load it now
          if (this.isRescheduling() && this.originalJobData) {
            setTimeout(() => {
              this.loadOriginalDataIfNeeded();
            }, 500); // Additional delay to ensure component is fully ready
          }
        }, 200); // Give component time to initialize
      }
      this.isLoadingBookingForms = false;
    } catch (err) {
      this.errorMessage = err?.error?.message ?? err?.message;
      this.logger.error(err);
      this.util.showError(this.errorMessage);
      console.error('err', err);
    } finally {
      this.isLoadingBookingForms = false;
      this.isLoadingDynamicForm = false;
    }
  }

  // Event handlers for dynamic booking form component
  onAttachmentsChange(attachments: any[]) {
    this.attachments = attachments;
  }

  onSelectedCheckboxesChange(selectedCheckboxes: any[]) {
    this.selectedCheckboxes = selectedCheckboxes;
  }

  onFormDataChange(event: any) {
    switch (event.type) {
      case 'componentInitialized':
        // If component is ready and we're in rescheduling mode, try to load original data
        if (event.isReady && this.isRescheduling() && this.originalJobData) {
          this.loadOriginalDataIfNeeded();
        } else if (event.isReady && this.preservedFormData) {
          // First mount with preserved form data from a previous BookJob
          // session — formsLoaded only fires on subsequent ngOnChanges, so we
          // restore here on the initial componentInitialized event. Defer
          // one tick so the parent's @ViewChild('dynamicBookingForm') ref is
          // resolved before restorePreservedFormData reads it.
          setTimeout(() => this.restorePreservedFormData(), 0);
        }
        break;

      case 'formsLoaded':
        // Check if we have both preserved data and are in rescheduling mode
        if (this.preservedFormData && this.isRescheduling() && this.originalJobData) {
          this.mergePreservedAndReschedulingData();
        } else if (this.isRescheduling() && this.originalJobData) {
          // If we're in rescheduling mode and have original job data, load original data
          this.loadOriginalDataIfNeeded();
        } else if (this.preservedFormData) {
          // If we have preserved form data from a pro change, restore it
          this.restorePreservedFormData();
        }
        break;

      case 'externalDataLoaded':
        break;

      case 'formDataChanged':
        // User has made changes to the form, update the preserved data if it exists
        if (this.preservedFormData) {
          this.updatePreservedFormData();
        }
        break;
    }
  }

  /**
   * Load original form data if this is a rescheduling flow
   */
  private async loadOriginalDataIfNeeded() {
    try {
      // Check if this is a rescheduling flow
      if (!this.isRescheduling() || !this.originalJobData) {
        return;
      }

      this.hasAttemptedToLoadOriginalData = true;

      // Get the original form answers from the job
      // Use the same approach as select-category page
      const originalFormAnswers = await this.schedule.getJobBookingFormAnswers(
        this.originalJobData.originalBookingId || this.jobId
      );

      if (originalFormAnswers && originalFormAnswers.length > 0) {
        // Wait for the dynamic form component to be ready
        await this.waitForDynamicFormReady();

        // Use the safer method to load external data
        if (this.dynamicBookingForm && this.dynamicBookingForm.isReady) {

                    // Check if user has already made changes to the form
          const currentUserInputs = this.preservedFormData;

          if (currentUserInputs && currentUserInputs.input_answers && currentUserInputs.input_answers.length > 0) {

            // Merge original data with user's current input, prioritizing user input
            const mergedData = this.mergeFormData(originalFormAnswers, currentUserInputs.input_answers);

            await this.dynamicBookingForm.safeLoadExternalData(mergedData);
          } else {
            // No user input yet, just load the original data
            await this.dynamicBookingForm.safeLoadExternalData(originalFormAnswers);
          }
        } else {
          // Form not ready
        }
      } else {
        // No original data to load
      }
    } catch (err) {
      // Don't throw error - form data loading failure shouldn't break the whole flow
    }
  }

    /**
   * Restore preserved form data (separate from rescheduling data loading)
   * This restores the user's latest input values, including any updates they made
   */
  private async restorePreservedFormData() {
    if (this.preservedFormData && this.dynamicBookingForm && this.dynamicBookingForm.isReady) {

      // Check if the new forms have compatible field IDs
      const newFormFieldIds = this.bookingForms?.[0]?.inputs?.map(input => input.id.toString()) || [];

      // Only restore data for fields that exist in the new forms
      const compatibleAnswers = this.preservedFormData.input_answers.filter(answer =>
        newFormFieldIds.includes(answer.input_id.toString())
      );

      if (compatibleAnswers.length > 0) {
        const formAnswers = compatibleAnswers.map(answer => ({
          input_id: answer.input_id,
          value: answer.value
        }));

        // Load the preserved data into the new forms
        await this.dynamicBookingForm.safeLoadExternalData(formAnswers);

        // Start monitoring form changes again to keep preserved data up-to-date
        this.startFormDataMonitoring();
      } else {
        // Clear preserved data if no compatible fields
        this.stopFormDataMonitoring();
        this.preservedFormData = null;
      }
    }
  }

  /**
   * Intelligently merge preserved user input with original rescheduling data
   * This ensures user updates are preserved when switching pros in rescheduling mode
   */
  private async mergePreservedAndReschedulingData() {
    try {
      // Get the original rescheduling data
      const originalFormAnswers = await this.schedule.getJobBookingFormAnswers(
        this.originalJobData.originalBookingId || this.jobId
      );

      if (originalFormAnswers && originalFormAnswers.length > 0) {
        // Merge the original rescheduling data with the preserved user input
        // User input should take precedence over original data
        const mergedData = this.mergeFormData(originalFormAnswers, this.preservedFormData.input_answers);

        // Load the merged data into the form
        if (this.dynamicBookingForm && this.dynamicBookingForm.isReady) {
          await this.dynamicBookingForm.safeLoadExternalData(mergedData);

          // Start monitoring form changes again to keep preserved data up-to-date
          this.startFormDataMonitoring();
        } else {
          // Form not ready
        }
      } else {
        // If no original data, just restore the preserved user input
        await this.restorePreservedFormData();
        return; // Exit early since restorePreservedFormData clears the preserved data
      }

      // Don't clear preserved data after successful merge - keep it for future updates
      // Only stop monitoring if we're not starting it again
      if (!this.dynamicBookingForm?.isReady) {
        this.stopFormDataMonitoring();
        this.preservedFormData = null;
      }

    } catch (err) {
      // Fallback: try to restore just the preserved data
      await this.restorePreservedFormData();
    }
  }

    /**
   * Check if this is a rescheduling flow
   */
  private isRescheduling(): boolean {
    return this.bookingType() === 'reschedule_plan' || this.bookingType() === 'reschedule_job';
  }

    /**
   * Merge original form data with user's current input, prioritizing user input
   * This ensures that user updates are preserved when patching data again
   */
  private mergeFormData(originalData: any[], userInputs: any[]): any[] {
    // TODO: Fix this motherfucker logic
    // Validate input data
    if (!originalData || !Array.isArray(originalData) || !userInputs || !Array.isArray(userInputs)) {
      return originalData || [];
    }

    const mergedData = [...originalData];

    // Create a map of user inputs for quick lookup, with null checks
    const userInputMap = new Map();
    userInputs.forEach(input => {
      if (input && input.input_id !== undefined && input.input_id !== null) {
        const inputId = input.input_id.toString();
        userInputMap.set(inputId, input);
      } else {
        // Invalid input, skip
      }
    });

    // Merge user inputs with original data, prioritizing user input
    mergedData.forEach((originalItem, index) => {
      if (originalItem && originalItem?.template_input?.id) {
        const originalInputId = originalItem?.template_input?.id.toString();
        const userInput = userInputMap.get(originalInputId);

        if (userInput) {
          // User has updated this field, use their value and preserve all user input properties
          mergedData[index] = {
            ...originalItem,
            ...userInput,
            data: {
              value: userInput?.value,
            }
          };
        }
      } else {
        // No valid input ID found
      }
    });

    // Add any new user inputs that weren't in the original data
    userInputs.forEach(userInput => {
      if (userInput && userInput.input_id !== undefined && userInput.input_id !== null) {
        const userInputId = userInput.input_id.toString();
        const exists = mergedData.some(item =>
          item && item.input_id !== undefined && item.input_id !== null &&
          item.input_id.toString() === userInputId
        );

        if (!exists) {
          mergedData.push(userInput);
        }
      }
    });

    return mergedData;
  }

  /**
   * Preserve the current form data before changing pro/service
   * This captures the user's latest input values, not just the original data
   */
  private preserveFormData() {
    if (this.dynamicBookingForm && this.dynamicBookingForm.isReady) {
      // Get the current form data from the dynamic form component (includes user updates)
      const currentFormData = this.dynamicBookingForm.buildBookingFormData();
      if (currentFormData && currentFormData.input_answers && currentFormData.input_answers.length > 0) {
        // Store the form data temporarily
        this.preservedFormData = currentFormData;

        // Start monitoring form changes to keep preserved data up-to-date
        this.startFormDataMonitoring();
      }
    }
  }

  /**
   * Update the preserved form data with current user input
   * This ensures the preserved data is always up-to-date with user changes
   */
  private updatePreservedFormData() {
    if (this.dynamicBookingForm && this.dynamicBookingForm.isReady && this.preservedFormData) {
      // Get the current form data from the dynamic form component
      const currentFormData = this.dynamicBookingForm.buildBookingFormData();
      if (currentFormData && currentFormData.input_answers && currentFormData.input_answers.length > 0) {
        // Update the preserved data with current user input
        this.preservedFormData = currentFormData;
      }
    }
  }

  /**
   * Start continuous monitoring of form changes to keep preserved data up-to-date
   */
  private startFormDataMonitoring() {
    if (this.preservedFormData && this.dynamicBookingForm) {

      // Set up a periodic check for form changes (every 2 seconds)
      this.formDataMonitoringInterval = setInterval(() => {
        this.updatePreservedFormData();
      }, 2000);

    }
  }

  /**
   * Stop continuous monitoring of form changes
   */
  private stopFormDataMonitoring() {
    if (this.formDataMonitoringInterval) {
      clearInterval(this.formDataMonitoringInterval);
      this.formDataMonitoringInterval = null;
    }
  }

  /**
   * Wait for the dynamic form component to be ready
   */
  private async waitForDynamicFormReady(): Promise<void> {
    if (this.dynamicBookingForm) {
      await this.dynamicBookingForm.waitForReady();
    }
  }

  async selectFrequency(frequency: RadioButtonModel) {
    // Set the user-facing state first so the template flips out of the
    // "select service to see times" alert even if a later step throws.
    this.choseFrequency.set(true);
    this.selectedFrequency.set(frequency.viewValue);
    this.showSavingsText = false;
    this.selectedPrice = this.selectedServiceData()?.price;
    this.moreTimesPerWeekSelected = ['twice_a_week', 'thrice_a_week'].includes(frequency.value);
    this.showMoreServices = false;
    const isMobileResolution = !this.windowService.isDesktopRes;
    if (!this.configuration()?.hide_frequency && !this.selectedPrivatePro() && this.selectedFrequency() === 'One Time' && this.bookingExperiment() === 'rental-v3' && !this.isUpdatingSubscription && !this.hasNonTrialPaidSubscription()) {
      if (!isMobileResolution) {
        const dialog = this.dialog.open(SubscriptionModalComponent, {
          panelClass: 'subcription-modal',
        })
        dialog.afterClosed().subscribe(async () => {
          await this.onDismissSubscriptionModal();
        })
      } else {
        this.modalCtrl.create({
          component: SubscriptionModalComponent,
          cssClass: 'subcription-modal',
          mode: 'ios',
          backdropDismiss: true,
          showBackdrop: true,
          breakpoints: [0, 0.4, 0.7, 0.8, 1],
          initialBreakpoint: 0.8,
          presentingElement: await this.modalCtrl.getTop(),
          canDismiss: true,
        }).then(modal => {
          modal.present();
          modal.onDidDismiss().then(async () => {
            await this.onDismissSubscriptionModal();
          })
        });
      }
    }
    this.frequencyValue.set(frequency.value);
    this.dateTimes.set([]);
    const startDay = (this.selectedPrivatePro() && !this.providedStartDateIsBeforeTomorrow) ? LuxonDateTime.fromFormat(this.providedStartDate, 'MM-dd-yyyy').toFormat('yyyy-MM-dd') : this.startDay;
    const request = this.buildTimeRequestPayload(frequency.value, startDay, this.endDay);
    try {
      this.isLoadingTimes = true;
      const times = this.selectedPrivatePro() ?
        await this.availableTimesForRange.getAvailableTimesPrivatePro(request) :
        await this.availableTimesForRange.getAvailableTimes(request);
      await this.handleTimeResponse(times);
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      this.util.showError(this.errorMessage);
      console.error('err', err);
      this.logger.error(err, 'book-job-trying-get-calendar');
    } finally {
      this.isLoadingTimes = false;
    }
    if (this.selectedPrivatePro() && !this.isLoggingJob) {
      this.buildDateSelect();
      this.form.get('privateDate')?.clearValidators();
      this.form.get('privateDate')?.updateValueAndValidity();
    }
    if (this.isLoggingJob) {
      const privateDate = LuxonDateTime.fromFormat(this.providedStartDate, 'MM-dd-yyyy');
      const reformattedDate = privateDate.toFormat('yyyy-MM-dd');
      this.form.patchValue({ privateDate: reformattedDate });
      this.form.get('privateDate')?.setValidators(Validators.required);
      this.form.get('privateDate')?.updateValueAndValidity();
    }
    this.showSavingsText = this.checkIfShouldShowSavingsText();
    this.resetDateLabel();

    // Check if we should auto-select the provided time
    this.selectProvidedTimeIfAvailable();
  }

  private selectProvidedTimeIfAvailable(): void {
    if (this.providedStartTime && this.dateTimes().length > 0 && !this.form.value.time) {
      const targetTime = this.providedStartTime.toLowerCase();

      for (const dateTime of this.dateTimes()) {
        const matchingTime = dateTime.times.find(t => t.viewValue === targetTime);
        if (matchingTime) {
          this.allTimesSelected = [matchingTime];
          this.selectedTime = matchingTime.viewValue;
          this.selectedDate = this.formatDate(matchingTime.value, 'dddd MMM d');
          this.form.patchValue({ time: matchingTime.value, pros: matchingTime.pros });
          break;
        }
      }
    }
  }

  async onDismissSubscriptionModal(): Promise<void> {
    this.hasNonTrialPaidSubscription.set(localStorage.getItem('hasNonTrialPaidSubscription') === 'true');
    this.isUpdatingSubscription = localStorage.getItem('isUpdatingSubscription') === 'true';
    this.currentSubscription = await this.storage.retrieve('currentSubscription');
    this.subscriptionType.set(this.me.getSubscriptionType(this.currentSubscription?.key));
    this.showSavingsText = this.checkIfShouldShowSavingsText();
  }

  resetDateLabel() {
    if (typeof this.selectedTimeValue !== 'string' || this.selectedTimeValue === '') {
      return;
    }
    let timeIsAvailable = false;
    const selectedDateTime = this.selectedTimeValue.split(" ");
    this.dateTimes().map((day) => {
      if (day.date === selectedDateTime[0]) {
        day.times.map((time) => {
          if (time.value === this.selectedTimeValue) {
            timeIsAvailable = true;
          }
        });
      }
    });
    if (timeIsAvailable) {
      this.dateLabel = this.getDateLabel();
    } else {
      this.form.patchValue({ time: '' });
      this.dateLabel = 'Select Date & Time'
    }
  }

  buildTimeRequestPayload(frequency, startDay, endDay) {
    return {
      frequency,
      start_date: startDay,
      end_date: endDay,
      region_id: this.address.region_id,
      address_id: this.address.id,
      service_type_key: this.form.value.service,
      filter: this.getFilterValue()
    };
  }

  private getFilterValue(): string {
    const value = this.selectedPro?.value || 'all';
    if (value === '4') {return 'all';}
    return value;
  }

  async handleTimeResponse(response: AvailableTimesModel) {
    this.noAvailableTimes.set(!response.available_times.length);
    if (this.noAvailableTimes() && this.proSelected() && !this.selectedPrivatePro()) {
      try {
        const hkId = this.form.value.proOption.replace('homekeeper:', '');
        this.proNotBookableReason = await this.homekeeper.getHkNotAvailableReason(hkId, this.form.value.service);
        this.minRateToBookWithPro.set(this.getMinRateToBookWithPro());
      } catch (err) {
        this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
        this.util.showError(this.errorMessage);
        console.error('err', err);
        this.logger.error(err);
      }
    }
    if (!this.noAvailableTimes()) {
      this.dateTimes.set(response.available_times.map( at => ({
        date: at.date,
        times: this.formatTimes(at)
      })));

      const isReschedule = this.bookingType() === 'reschedule_job' || this.bookingType() === 'reschedule_plan';
      if (!this.hasTrackedDateTimeReached && !isReschedule && this.choseService()) {
        this.posthogService.capture('booking_date_time_reached', {
          variant: 'control',
          has_credit_card: this.hasValidCC(),
          booking_type: this.bookingType(),
          is_desktop: this.windowService.isDesktopRes,
          is_house_cleaning: this.isHouseCleaningSelected,
        });
        this.hasTrackedDateTimeReached = true;
      }

      // Check if we should auto-select the provided time
      this.selectProvidedTimeIfAvailable();
    }
  }

  getMinRateToBookWithPro() {
    if (this.proNotBookableReason.not_bookable_reason.includes('rate is set at a minimum')) {
      return this.extractNumberFromString(this.proNotBookableReason.not_bookable_reason);
    } else {
      return null;
    }
  }

  extractNumberFromString(string) {
    const regex = /minimum of \$([\d,]+(?:\.\d{1,2})?)/;
    const match = string.match(regex);
    return match ? parseFloat(match[1].replace(/,/g, '')) * 100 : null;
  }

  async buildDateSelect() {
    const parseDatePipe = new ParseDateTimePipe();
    this.privateJobDates = [
      {
        value: this.startDay,
        viewValue: parseDatePipe.transform(this.startDay, 'EEEE LLLL d')
      }
    ];
    for (let i = 1; i <= 27; i++) {
      const luxonDate = LuxonDateTime.fromISO(this.startDay).plus({ days: i });
      const isoDate = luxonDate.toISODate();
      this.privateJobDates.push({
        value: isoDate,
        viewValue: parseDatePipe.transform(isoDate, 'EEEE LLLL d')
      });
    }
    if (this.providedStartDate) {
      const date = LuxonDateTime.fromFormat(this.providedStartDate, 'MM-dd-yyyy');
      const today = LuxonDateTime.local();
      const privateDate = this.isDateWithinThisWeek(date) ? date : today;
      const reformattedDate = privateDate.toFormat('yyyy-MM-dd');
      const dateIsDisplaying = this.privateJobDates.find((item) => item.value === reformattedDate);
      if (dateIsDisplaying) {
        this.form.patchValue({ privateDate: reformattedDate });
      } else {
        this.form.patchValue({ privateDate: this.privateJobDates[0].value });
      }
    } else {
      this.form.patchValue({ privateDate: this.startDay });
    }
  }

  isDateWithinThisWeek(date: LuxonDateTime): boolean {
    const today = LuxonDateTime.local();
    const todayMoreSeven = today.plus({ days: 7 });
    return date >= today && date <= todayMoreSeven;
  }

  async changeDay(day) {
    this.isLoadingPrivateTimes = true;
    if (this.isLoggingJob) {
      this.selectedDate = this.formatLoggingJobDate();
      this.dateLabel = this.getDateLabel();
    }
    try {
      const request = this.buildTimeRequestPayload(this.frequencyValue(), day, this.endDay);
      const times = await this.availableTimesForRange.getAvailableTimesPrivatePro(request);
      await this.handleTimeResponse(times);
    } catch(err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      this.util.showError(this.errorMessage);
      console.error('err', err);
      this.logger.error(err);
    }
    this.isLoadingPrivateTimes = false;
  }

  formatTimes(at) {
    if (this.selectedPrivatePro()) {
      const idArray = [];
      const selectedProId = this.selectedPro.value.replace('homekeeper:', '');
      idArray.push(selectedProId);
      return at.times.map( t => {
        const timeString = `${at.date}T${t}`;
        const luxonDateTime = LuxonDateTime.fromISO(timeString);
        return {
          value: `${at.date} ${t}`,
          viewValue: luxonDateTime.toFormat('h:mma').toLowerCase(),
          pros: idArray
        };
      });
    } else {
      return at.times.map( t => {
        const timeString = `${at.date}T${t.time}`;
        const luxonDateTime = LuxonDateTime.fromISO(timeString);
        return {
          value: `${at.date} ${t.time}`,
          viewValue: luxonDateTime.toFormat('h:mma').toLowerCase(),
          pros: t.hk_ids
        };
      });
    }
  }

  selectTime(time: { value: string, viewValue: string, pros: number[]}, idx) {
    console.warn('[selectTime] Called with:', { time, idx, moreTimesPerWeekSelected: this.moreTimesPerWeekSelected });
    this.allTimesSelected = [time];
    if (this.isLoggingJob) {
      if (this.form.value.privateDate) {
        this.selectedDate = this.formatLoggingJobDate();
      }
      this.selectedTime = this.formatLoggingJobTime(time.value);
      this.selectedTimeValue = time.value;
    } else {
      this.selectedDate = this.formatDate(time.value, 'ddd MMM d');
      this.selectedTime = time.viewValue;
      this.selectedTimeValue = time.value;
    }
    this.dateLabel = this.getDateLabel();
    this.secondDateLabel = this.getSecondDateLabel();
    this.thirdDateLabel = this.getThirdDateLabel();
    if (this.moreTimesPerWeekSelected) {
      this.form.patchValue({ time: null });
      this.openMoreTimesModal(time, idx);
    } else {
      // Explicitly set the time value to ensure form validity
      this.form.patchValue({ time: time.value, pros: time.pros });
    }
  }

  formatLoggingJobDate() {
    const luxonDate = LuxonDateTime.fromJSDate(new Date(this.form.value.privateDate));
    return new ParseDateTimePipe().transform(luxonDate.toISODate(), 'MMM d');
  }

  formatLoggingJobTime(time) {
    const luxonTime = LuxonDateTime.fromFormat(time, 'HH:mm');
    return luxonTime.toFormat('h:mma').toLowerCase();
  }

  async openMoreTimesModal(time, idx) {
    const changedEvent: EventEmitter<ModalMoreTimeDataModel> = new EventEmitter<ModalMoreTimeDataModel>();
    const sixDaysAfterFirstTime = this.dateTimes().slice(idx + 1, idx + 7);

    const params = {
      firstTime: [this.formatDate(time.value, 'ddd MMM d'), time.viewValue].filter(Boolean).join(' at '),
      dateTimes: sixDaysAfterFirstTime,
      thriceAWeek: this.form.value.frequency === 'thrice_a_week',
      frequencyLabel: this.serviceFrequencyLabelSignal(),
      selectedPrice: this.selectedPrice,
      eventEmitter: changedEvent
    }
    const modal = await this.modalCtrl.create({
      component: ModalMoreTimesPage,
      componentProps: params,
      showBackdrop: false,
      cssClass: 'tidy-custom-modal'
    });

    this.subscriptions.push(changedEvent.subscribe((data: ModalMoreTimeDataModel) => {
      this.setSelectedTimes(time, data);
    }));

    modal.onDidDismiss().then((result) => {
      this.setSelectedTimes(time, result?.data);
    });

    await modal.present();
  }

  setSelectedTimes(firstTime, data: ModalMoreTimeDataModel): void {
    if (data?.completed) {
      this.allTimesSelected = [
        firstTime,
        ...data.timesSelected
      ]
      this.selectedDate = this.formatDate(firstTime.value, 'dddd MMM d');
      this.selectedTime = firstTime.viewValue;
      this.form.patchValue({ time: firstTime.value, pros: firstTime.pros })
      this.secondDateLabel = this.getSecondDateLabel();
      this.thirdDateLabel = this.getThirdDateLabel();
    }
  }

  async confirmBooking() {
    try {
      this.submitted = true;
      this.hasBookingFormError = false;
      if (this.bookingForms?.length > 0 && (!this.bookingForm.valid || this.hasImageUploadError)) {
        this.hasBookingFormError = true;
        return;
      }
      await this.saveBookingChooserState();
      const isJobRequest = false;
      const selectedPrivatePro = this.selectedPrivatePro();
      const selectedServiceData = this.selectedServiceData();
      const isUpdatingSubscription = this.isUpdatingSubscription;
      const hasNonTrialPaidSubscription = this.hasNonTrialPaidSubscription();
      const didSelectPro = this.selectedPro?.value?.includes('homekeeper:') ?? false;
      const address = this.address;
      const proName = didSelectPro ? this.selectedPro?.viewValue : null;
      const planId = this.planId();
      const values = this.form.value;
      const bookingType = this.bookingType();
      const flowType = this.flowType;
      const viewData = this.buildViewData();
      const { bookingId, jobId, allTimesSelected, isLoggingJob } = this;
      const dates = this.buildSelectedDates(allTimesSelected);
      if (!dates.length) {
        this.form.patchValue({ time: null });
        this.util.showError('Please select a time.');
        return;
      }
      let bookData = this.buildBookData(values, dates);
      if (this.bookingForms?.length > 0) {
        bookData = this.addBookingFormData(bookData);
      }
      const addressId = this.address.id;
      const shouldInsteadAddJob = this.shouldInsteadAddJob;
      const isProRequest = false;
      if (this.shouldInsteadAddJob) {
        bookData.address_id = this.address.id;
      }
      const serviceTypeKey = values.service;
      const homekeeperId = dates[0]?.homekeeper_ids[0];
      try {
        if (!this.hasValidCC() && !this.selectedPrivatePro()) {
          const params = { isProRequest, selectedPrivatePro, selectedServiceData, hasNonTrialPaidSubscription, isUpdatingSubscription, planId, bookingType, flowType, bookData, viewData, bookingId, jobId, isJobRequest, customBackRoute: 'book-job' }
          const url = 'confirm-booking-payment';
          const component = ConfirmBookingPaymentPage;
          if (this.isRightSideContent) {
            this.rightSidePanelService.navigateTo(url, params, component);
          } else {
            this.navCtrl.navigateForward(url, params);
          }
        } else {
          const hasValidCC = this.hasValidCC();
          const params = { isProRequest, selectedPrivatePro, selectedServiceData, hasNonTrialPaidSubscription, isUpdatingSubscription, address, addressId, proName, planId, bookingType, flowType, bookData, viewData, bookingId, jobId, isLoggingJob, shouldInsteadAddJob, serviceTypeKey, homekeeperId, isJobRequest, hasValidCC, customBackRoute: 'book-job' }
          const url = 'confirm-booking';
          const component = ConfirmBookingPage;
          if (this.isRightSideContent) {
            this.rightSidePanelService.navigateTo(url, params, component);
          } else {
            this.navCtrl.navigateForward(url, params);
          }
        }
      } catch (err) {
        this.errorMessage = err.error ? err.error.message : err.message;
        this.util.showError(this.errorMessage);
        console.error('err', err);
        this.logger.error(err, 'confirm-booking-redirect');
      }
    } catch (err) {
      this.errorMessage = err.error ? err.error.message : err.message;
      this.util.showError(this.errorMessage);
      console.error('err', err);
      this.logger.error(err, 'confirm-booking-redirect');
    }
  }

  addBookingFormData(bookData) {
    // Use the dynamic form component to build the booking form data
    if (this.dynamicBookingForm && this.dynamicBookingForm.isReady) {
      const dynamicFormData = this.dynamicBookingForm.buildBookingFormData();
      bookData['booking_form'] = dynamicFormData;
    } else {
      // Fallback to empty form data if dynamic form component is not ready
      bookData['booking_form'] = {
        input_answers: []
      }
    }
    return bookData;
  }

  // getFormValue method removed - now handled by dynamic-booking-form component

  buildBookData(values, dates) {
    if ((this.configuration()?.title !== 'Reschedule' && values.frequency === 'once') || this.isLoggingJob) {
      this.configuration.set(bookJobConfigurations['add_one_time_job']);
    }
    return this.configuration().buildBookingData({
      addressId: this.address.id,
      frequency: values.frequency === null ? 'once' : values.frequency,
      planId: this.planId(),
      serviceTypeKey: values.service,
      dates,
      ratingChosen: this.ratingChosen,
      hkRating: this.bookJobService.parseFilterToRating(values.proOption)
    });
  }

  buildSelectedDates(allTimesSelected) {
    if (this.isLoggingJob) {
      return [
        {
          date: this.form.value.privateDate,
          time: this.form.value.time,
          homekeeper_ids: [this.selectedPro.value.replace('homekeeper:', '')]
        }
      ];
    } else {
      return allTimesSelected.map(dateTime => ({
        date: dateTime.value.split(' ')[0],
        time: dateTime.value.split(' ')[1],
        homekeeper_ids: dateTime.pros,
      }));
    }
  }

  formatDate(dateTime, format) {
    // Convert the input date string (e.g., "2025-03-04 14:00") to a proper ISO format
    // First, check if it's already in ISO format
    if (!dateTime.includes('T') && dateTime.includes(' ')) {
      // Replace space with 'T' to make it ISO format
      const [datePart, timePart] = dateTime.split(' ');
      dateTime = `${datePart}T${timePart}`;
    }
    return new ParseDateTimePipe().transform(dateTime, format);
  }

  buildViewData() {
    const data = {
      service: this.selectedService(),
      frequency: this.selectedFrequency(),
      image: this.selectedServiceImage,
      isHouseCleaning: this.categoryId === 1,
      dateTime: this.getDateLabel(),
      price: this.selectedPrice,
      duration: this.selectedDuration,
      billingType: this.selectedBillingType
    };
    if (this.form.value.frequency === 'twice_a_week' || this.form.value.frequency === 'thrice_a_week') {
      data['dateTimeTwo'] = this.getSecondDateLabel();
    }
    if (this.form.value.frequency === 'thrice_a_week') {
      data['dateTimeThree'] = this.getThirdDateLabel();
    }
    return data;
  }

  showService(service) {
    const isTheOneSelected = this.form.value.service === service.key;
    return !this.choseService()
            || this.showMoreServices
            || isTheOneSelected;
  }

  showServices() {
    this.showMoreServices = true;
  }

  calculateShowRequestPro() {
    const isOneTimeJob = this.form.value.frequency === 'once' || this.bookingType() === 'add_one_time_job';
    const isFreqTwiceThrice = this.frequencyValue() !== 'thrice_a_week' && this.frequencyValue() !== 'twice_a_week';
    if (this.bookingType() !== 'reschedule_plan' && this.bookingType() !== 'reschedule_job' && !this.noAvailableTimes() && (this.selectedPrivatePro() || this.proSelected()) && (this.choseFrequency() || (this.choseService() && isOneTimeJob)) && isFreqTwiceThrice) {
      return true;
    }
    else {
      return false;
    }
  }

  calculateShowRequestJob() {
    const isOneProJob = !this.form.value.service.includes('turnover');
    const isOneTimeJob = this.form.value.frequency === 'once'
      || this.frequencyValue() === 'once'
      || this.bookingType() === 'add_one_time_job';
    const isReschedule = this.bookingType() === 'reschedule_plan' || this.bookingType() === 'reschedule_job';
    const hasAvailableTimes = this.dateTimes().length > 0;
    const isNonCleaning = this.categoryId !== 1;
    if (isNonCleaning && isOneProJob && isOneTimeJob && !isReschedule) {
      return true;
    }
    return isOneProJob && isOneTimeJob && !this.proSelected() && hasAvailableTimes && !isReschedule;
  }

  async goToRequestJob() {
    await this.saveBookingChooserState();
    this.storage.delete('bookingFormAnswers');
    this.storage.delete('attachments');
    const params: any = {
      isPrivateFlow: this.selectedPrivatePro(),
      selectedService: this.selectedServiceData(),
      address: this.address,
      planId: this.planId(),
      bookingId: this.bookingId,
      bookingType: this.bookingType(),
      services: this.services(),
      hasNonTrialPaidSubscription: this.hasNonTrialPaidSubscription(),
      selectedFrequency: this.selectedFrequency(),
      priceExperiment: this.priceExperiment(),
      bookingExperiment: this.bookingExperiment(),
      bookingFormAnswers: this.dynamicBookingForm?.isReady ? this.dynamicBookingForm.buildBookingFormData() : null,
      attachments: this.attachments,
      originalJobData: this.originalJobData,
      isRescheduling: this.isRescheduling()
    }
    try {
      const substituteData = await this.availableTimesForRange.checkIfCanRequestSubstitute();
      const substituteJobId = substituteData.substitute_available_for_job_id;
      if (substituteJobId !== null) {
        const url = `request-substitute/${substituteJobId}`;
        params.jobId = substituteJobId;
        this.rightSidePanelService.navigateTo(url, params, RequestSubstitutePage);
        return;
      }
    } catch {
      // If substitute check fails, fall through to normal request flow
    }
    const url = 'request-job';
    const component = RequestJobPage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  goToRequestPro() {
    this.storage.delete('bookingFormAnswers');
    this.storage.delete('attachments');
    const pro = this.pros.find(item => item.filter === this.form.value.proOption);
    const params = {
      addingOneTimeJob: this.bookingType() === 'add_one_time_job',
      cameFromBookJob: true,
      services: this.services(),
      address: this.address,
      planId: this.planId(),
      bookingType: this.bookingType(),
      hasNonTrialPaidSubscription: this.hasNonTrialPaidSubscription(),
      priceExperiment: this.priceExperiment(),
      bookingExperiment: this.bookingExperiment(),
      service: {
        viewValue: this.selectedService(),
        value: this.form.value.service
      },
      frequency: {
        viewValue: this.selectedFrequency(),
        value: this.frequencyValue()
      },
      pro: {
        first_name: this.selectedPro.viewValue,
        id: this.form.value.proOption,
        private: pro.private
      },
      bookingFormAnswers: this.bookingForm.value,
      attachments: this.attachments
    };
    const url = 'request-pro';
    const component = RequestProPage;
    this.rightSidePanelService.navigateTo(url, params, component);
  }

  //TODO The purpose of the 3 following methods is to convert new string values into older string values.
  //We can remove these 3 method when we refactor SDC / CRAF pages to use newer string values.

  formatTypeOfPlan() {
    const newType = this.bookingType();
    const oldTypes = {
      'reschedule_job': 'reschedule-cleaning',
      'add_one_time_job': 'add-cleaning',
      'reschedule_plan': 'reschedule-plan',
      'add_job': 'schedule-plan',
    }
    return oldTypes[newType];
  }

  formatPlanFrequency() {
    const newType = this.selectedFrequency();
    const oldTypes = {
      'One Time': 'once',
      'One Time (+25%)': 'once',
      'Every 4 Weeks': 'every_four_weeks',
      'Every 2 Weeks': 'every_other_week',
      'Weekly': 'every_week',
      '2x Per Week': 'twice_a_week',
      '3x Per Week': 'thrice_a_week'
    }
    return oldTypes[newType];
  }

  formatPlanType() {
    const newType = this.form.value.service;
    if (newType.includes('regular_cleaning.one_hour')) {
      return 'tidy';
    } else if (newType.includes('regular_cleaning.two_and_a_half_hours')) {
      return 'plus';
    } else if (newType.includes('regular_cleaning.four_hours')) {
      return 'tidy_xl';
    }
  }

  displayTodayLabel() {
    const now = LuxonDateTime.now();
    const cutoffTime = LuxonDateTime.fromFormat('19:50', 'HH:mm');
    return now < cutoffTime;
  }

  showAnyRatingFilter() {
    this.newValue = 'all';
    this.form.patchValue({ proOption: 'all' });
    this.selectedPro = {
      value: 'all',
      viewValue: 'Any Rating'
    };
    this.proSelected.set(false);
    if (!this.selectedPrivatePro()) {
      this.selectFrequency({ value: this.frequencyValue(), viewValue: this.selectedFrequency() });
    } else {
      this.fetchServices('all', true);
    }
  }

  getDateLabel() {
    if ((!this.selectedDate || !this.selectedTime) && !this.moreTimesPerWeekSelected) {
      return new TranslationPipe().transform('Select Date & Time');
    } else if ((!this.selectedDate || !this.selectedTime) && this.moreTimesPerWeekSelected) {
      return new TranslationPipe().transform('Select First Time');
    }
    const dateLabel = [this.selectedDate, this.selectedTime].filter(Boolean).join(' ');
    if (this.frequencyValue() === 'once') {
      return dateLabel;
    } else {
      return (new TranslationPipe()).transform('Starts ') + dateLabel;
    }
  }

  getSecondDateLabel() {
    if (this.allTimesSelected.length < 2) {
      return new TranslationPipe().transform('Select Second Time');
    }
    const date = this.formatDate(this.allTimesSelected[1].value, 'ddd MMM d');
    const dateLabel = [date, this.allTimesSelected[1].viewValue].filter(Boolean).join(' ');
    if (this.frequencyValue() === 'once') {
      return dateLabel;
    } else {
      return (new TranslationPipe()).transform('Starts ') + dateLabel;
    }
  }

  getThirdDateLabel() {
    if (this.allTimesSelected.length < 3) {
      return new TranslationPipe().transform('Select Third Time');
    }
    const date = this.formatDate(this.allTimesSelected[2].value, 'ddd MMM d');
    const dateLabel = [date, this.allTimesSelected[2].viewValue].filter(Boolean).join(' ');
    if (this.frequencyValue() === 'once') {
      return dateLabel;
    } else {
      return (new TranslationPipe()).transform('Starts ') + dateLabel;
    }
  }

  showAllFrequencies() {
    this.frequencyOrder = [0,1,4,2,3,5];
  }

  showIssueLoadingPageAlert() {
    const shouldShowAllToDosPage = localStorage.getItem('shouldShowAllToDosPage') === 'true';
    this.storage.save('shouldReloadSchedule', 'true');
    const params = {
      header: 'Issue Accessing Page',
      body: 'Please try again from your Schedule and the issue should be resolved.  Thanks for your patience.',
      buttonText: 'Go to Schedule',
      buttonRoute: shouldShowAllToDosPage || this.windowService.isDesktopRes ? 'schedule' : 'schedule-list'
    };
    this.rightSidePanelService.navigateTo('success', params);
    this.rightSidePanelService.setDialogLoading(false);
  }

  async turnOnTidyFindNewPros() {
    const data = {
      service_type_id: 1,
      key: 'substitutes_on'
    };
    try {
      this.waterfallSettings = await this.client.updateWaterfallSettings(data);
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      this.util.showError(this.errorMessage);
      console.error('err', err);
    }
  }

  goToAddPro() {
    const params = {
      categoryId: 1
    }
    this.rightSidePanelService.navigateTo('add-pro', params);
  }

  checkIfShouldShowSavingsText() {
    const isOneTimeJobPlan = this.selectedFrequency() === 'One Time' || this.selectedFrequency() === 'One Time (+25%)';
    const savingsText = this.getSavingsText();
    if (!savingsText) {
      return false;
    } else if (this.selectedFrequency() === 'One Time' && this.choseFrequency() && this.subscriptionExperiment() === 'showInlineSubscriptionSales' && !this.hasNonTrialPaidSubscription()) {
      return false;
    } else if (!this.hasNonTrialPaidSubscription() && this.priceExperiment() !== 'showCrossedOutDiscount') {
      return false;
    } else if (this.bookingType() !== 'add_one_time_job' && !this.selectedPrivatePro()) {
      if (this.priceExperiment() !== 'showCrossedOutDiscount' && !isOneTimeJobPlan) {
        return false;
      } else {
        return true;
      }
    } else {
      return false;
    }
  }

  getSavingsText() {
    const isOneTimeJobPlan = this.selectedFrequency() === 'One Time' || this.selectedFrequency() === 'One Time (+25%)';
    if (isOneTimeJobPlan && this.hasNonTrialPaidSubscription() && this.choseFrequency()) {
      return new TranslationPipe().transform('Saving ') + (this.selectedFrequency() === 'One Time (+25%)' ? '25%' : '20%') + new TranslationPipe().transform(' with your ') + this.subscriptionType() + new TranslationPipe().transform(' subscription!');
    } else if (isOneTimeJobPlan) {
      if (this.bookingExperiment() === 'consumer-test2' && !this.hasValidCC()) {
        return '$10 coupon applied!';
      } else if (this.subscriptionExperiment() === 'showInlineSubscriptionSales') {
        return 'Upgrade to TIDY+ to save 20%';
      } else if (this.bookingExperiment() === 'rental-v1a' || this.bookingExperiment() === 'rental-v1b' || this.bookingExperiment() === 'consumer-test1') {
        return 'Select a recurring plan to save 20%';
      }
    } else if (this.priceExperiment() === 'showCrossedOutDiscount') {
      return 'Saving 20% with a recurring plan!';
    } else {
      return null;
    }
  }

  @Loading('', true)
  async updateSubscription() {
    this.isUpdatingSubscription = !this.isUpdatingSubscription;
    localStorage.setItem('isUpdatingSubscription', this.isUpdatingSubscription ? 'true' : ' false');
    this.hasNonTrialPaidSubscription.set(!this.hasNonTrialPaidSubscription());
    if (this.isUpdatingSubscription) {
      this.subscriptionType.set('TIDY+');
      localStorage.setItem('hasNonTrialPaidSubscription', 'true');
      this.currentSubscription = this.tidyPlusSubscription;
      this.storage.save('currentSubscription', this.tidyPlusSubscription);
    } else {
      localStorage.setItem('hasNonTrialPaidSubscription', 'false');
      this.storage.delete('currentSubscription');
    }
    this.showSavingsText = this.checkIfShouldShowSavingsText();
  }

  goToViewSubscriptions() {
    const params = {
      isBookingJob: true,
      nextBookingPage: 'book-job'
    }
    this.rightSidePanelService.navigateTo('select-subscription', params);
  }

  async logJob() {
    this.isLoggingJob = !this.isLoggingJob;
    if (this.isLoggingJob) {
      this.form.get('privateDate')?.setValidators(Validators.required);
    } else {
      this.form.get('privateDate')?.clearValidators();
    }
    this.form.get('privateDate')?.updateValueAndValidity();
    const today = LuxonDateTime.local().toFormat('MM-dd-yyyy');
    const parsedDate = LuxonDateTime.fromFormat(this.providedStartDate || today, 'MM-dd-yyyy').plus({ days: 1 }).toISODate();
    this.form.patchValue({ privateDate: parsedDate });
  }

  goToContactConcierge() {
    const params = {
      title: 'Booking Question',
      type: 'support.other'
    };
    return this.rightSidePanelService.navigateTo('contact-concierge', params);
  }

  async changeServiceRates() {
    try {
      const currentPrices =  await this.addresses.getPriceTable(this.address.id);
      const payload = {new_prices: []};
      currentPrices.map((service) => {
        if (service.key === this.form.value.service) {
          payload.new_prices.push({
            no_team_address_service_id: service.id,
            price: this.minRateToBookWithPro()
          });
        } else if (service.billing_type !== 'price_later') {
          payload.new_prices.push({
            no_team_address_service_id: service.id,
            price: service.prices.base_price
          });
        }
      });
      await this.addresses.changePrices(this.address.id, payload);
      await this.changeFilter(this.form.value.proOption);
      await this.selectFrequency({ value: this.frequencyValue(), viewValue: this.selectedFrequency() });
      this.form.patchValue({
        frequency: this.frequencyValue()
      });
      this.choseFrequency.set(true);
      this.selectedFrequency.set(this.form.value.frequency);
      this.frequencyValue.set(this.form.value.frequency);
      const successMessage = 'Rates updated!';
      this.util.showSuccess(successMessage);
    } catch (err) {
      this.errorMessage = (err.error && err.error.message) ? err.error.message : err.message;
      this.util.showError(this.errorMessage);
      console.error('err', err);
    }
  }

  onDestroy() {
    this.subscriptions.forEach(subscription => {
      subscription.unsubscribe();
    });
  }

}

